/**
* @file 左侧边栏
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, useEffect, useRef} from 'react';
import {headerHeightMap} from '@/constants';
import SecondaryNav from '../SecondaryNav';
import ProductNavigator from '../ProductNavigator';
import SearchInput from '../SearchInput';
import flattenTree from '@/hooks/useSearchInput/flattenTree';

const SITE_HEADER_HEIGHT = headerHeightMap["acg-portal-en"];

type SiderProps = {
    name: string
    description: string
    menuItems: TreeNestedItem[],
    pageContext: any
    slugName: string
    api?: string
    template?: string
}

const Sider: FunctionComponent<SiderProps> = ({
    name,
    description,
    menuItems,
    pageContext,
    slugName,
    api,
    template = 'default'
}) => {
    const sider:any = useRef();

    useEffect(() => {
        window.onscroll = () => {
            const scrollTop = document.body.getBoundingClientRect().top;
            if (scrollTop < -(SITE_HEADER_HEIGHT + 20)) {
                sider.current.className = "sider fixed"
            }
            else {
                sider.current.className = "sider"
            }
        };
    });

    const computeBranchNodeOffset = (depth: number) => {
        return depth === 0 ? 0 : 10 * depth;
    };

    const computeLeafNodeOffset = (depth: number) => {
        return 10 * depth;
    };

    return (
        <section ref={sider} className="sider">
            <div className="head">
                <span className="desc">All Product Document</span>
                <ProductNavigator api={api} template={template} />
            </div>
            <h2 className="name">{description} {name}</h2>
            <div className="search-wrapper">
                <SearchInput dataSource={flattenTree(menuItems)} />
            </div>
            <SecondaryNav
                items={menuItems}
                name={name}
                slugName={slugName}
                pageContext={pageContext}
                computeBranchNodeOffset={computeBranchNodeOffset}
                computeLeafNodeOffset={computeLeafNodeOffset}
            />
        </section>
    );
};

export default Sider;
